import React from "react";
import classNames from "classnames/bind";

import styles from "./Button.module.scss";
const cx = classNames.bind(styles);

const Button = ({
  PrefixIcon,
  SufixIcon,
  label,
  classname,
  variant = "primary",
}) => {
  return (
    <button className={cx("btn-root", variant, classname)}>
      {PrefixIcon && <PrefixIcon />}
      <span>{label}</span>
      {SufixIcon && <SufixIcon />}
    </button>
  );
};

export default Button;
